export const SET_INITIALISED = 'app/SET_INITIALISED';

export const SET_DATA = 'app/SET_DATA';

export const SET_BASEPATH = 'app/SET_BASEPATH';

export const SET_ERROR = 'app/SET_ERROR';

export const SET_BASKET_ITEMS = 'app/SET_BASKET_ITEMS';

export const SET_BASKET_SUMMARY = 'app/SET_BASKET_SUMMARY';

export const SET_CATALOG_LIST = 'app/SET_CATALOG_LIST';

export const SET_PARTS_MODAL_PAGE = 'app/SET_PARTS_MODAL_PAGE';

export const SET_PARTS_LIST = 'app/SET_PARTS_LIST';

export const SET_HIGHLIGHTED_PART = 'app/SET_HIGHLIGHTED_PART';

export const SET_BIKE = 'app/SET_BIKE';

export const SET_DELIVERY_METHOD = 'app/SET_DELIVERY_METHOD';

export const SET_GEOLOCATION = 'app/SET_GEOLOCATION';

export const SET_SELECTED_DEALER = 'app/SET_SELECTED_DEALER';

export const SET_STEP = 'app/SET_STEP';

export const SET_FORM_VALUES = 'app/SET_FORM_VALUES';

export const SET_LOADED_CONFIGURATION = 'app/SET_LOADED_CONFIGURATION';
